import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { ReadContentVersionsDocument } from './types'

/**
 * Reads the version history for a single content, newest first. The `content`
 * filter takes the content UUID; `editor` is included so the rail can show authors.
 */
export const readContentVersions = async ({
  contentUuid,
}: {
  contentUuid: string
}): Promise<ReadContentVersionsDocument> => {
  const url = new URL('/v3/content_versions', window.location.origin)

  url.search = queryString({
    filter: { content: contentUuid },
    include: ['editor'],
  })

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
